import { put, call, takeEvery } from "redux-saga/effects";
import { safe } from "providers/GeneralProvider/saga";
import {
  getHealthInsuranceContentRequest,
  getHealthInsuranceContentSuccess,
  getHealthInsuranceContentFailure,
  updateHealthInsuranceRequest,
  updateHealthInsuranceSuccess,
  updateHealthInsuranceFailure,
} from "./slice";
import request from "utils/api";
import Helper from "utils/helpers";

function* getHealthInsuranceContent({ meta }) {
  try {
    const { data } = yield call(request, "api/health/insurance-content", {}, {
      method: "GET",
    });

    yield put(getHealthInsuranceContentSuccess(data, meta));
  } catch (error) {
    // If 404, it means no content yet, which is not an error
    if (error.status === 404) {
      yield put(getHealthInsuranceContentSuccess(null, meta));
    } else {
      yield put(getHealthInsuranceContentFailure(error.message, meta));
    }
  }
}

function* updateHealthInsurance({ meta, payload }) {
  try {
    const { data } = yield call(request, "api/health/insurance", payload, {
      method: "PUT",
    });

    yield put(updateHealthInsuranceSuccess(data, meta));
    Helper.toastr("Thành công", "Đã cập nhật nội dung Bảo hiểm - Quy trình", "success");
  } catch (error) {
    yield put(updateHealthInsuranceFailure(error.message, meta));
    Helper.toastr("Lỗi", "Không thể cập nhật nội dung", "error");
  }
}

function* healthInsuranceSaga() {
  yield takeEvery(getHealthInsuranceContentRequest.type, safe(getHealthInsuranceContent));
  yield takeEvery(updateHealthInsuranceRequest.type, safe(updateHealthInsurance));
}

export default healthInsuranceSaga;
